/**
 * Event names must be string, else vue will get headaches.
 */
const CONSTANTS = Object.freeze({
  NODE_SELECTED_EVENT: "1",
  VTS_SELECTED_EVENT: "2",
  HOVER_EVENT: "7",
  COLORING_EVENT: "14",
  CELL_TYPE: {
    SINGLE_BAR: "3",
    HORIZONTAL_BARS: "4",
    VERTICAL_BARS: "5",
    MATRIX: "6"
  },
  COMPONENT_NAMES: {
    SVG_GRID: "8",
    SELECTION_DETAILS: "9",
    NODELINK: "10"
  },
  COLORING_TYPE: {
    NODES: "11",
    TIMESTEPS: "12",
    VARIANTS: "13"
  }
});

export default CONSTANTS;
